import { useState } from 'react';
import { supabase } from '../supabase';
 
const INDIVIDUAL_PLANS = [
  {
    name: 'Starter',
    price: '$49',
    priceId: 'price_1TPq18Kvsr6YPyDcPE62Vb3C',
    features: ['Script step navigation', 'Script library', 'Objection library', 'One-tap objection responses'],
    color: '#4ade80',
    dim: 'rgba(74,222,128,0.1)',
    border: 'rgba(74,222,128,0.25)',
  },
  {
    name: 'Pro',
    price: '$99',
    priceId: 'price_1TPqHbKvsr6YPyDcxNeJq7iy',
    features: ['Everything in Starter', 'Live mic — unlimited', 'Auto-detects objections', 'AI assist for unknown objections', 'EN/ES language toggle'],
    color: '#60a5fa',
    dim: 'rgba(96,165,250,0.1)',
    border: 'rgba(96,165,250,0.25)',
    popular: true,
  },
  {
    name: 'Elite',
    price: '$149',
    priceId: 'price_1TPqIZKvsr6YPyDc3qERJVaz',
    features: ['Everything in Pro', 'Early access to new features', 'Call analytics (coming soon)', 'Call history (coming soon)'],
    color: '#a78bfa',
    dim: 'rgba(167,139,250,0.1)',
    border: 'rgba(167,139,250,0.25)',
  },
];
 
const AGENCY_PLANS = [
  {
    name: 'Agency Starter',
    price: '$199',
    priceId: 'price_1TPqJbKvsr6YPyDcoCCElzwO',
    features: ['Up to 5 agents', 'All Starter features per agent'],
    color: '#fb923c',
    dim: 'rgba(251,146,60,0.1)',
    border: 'rgba(251,146,60,0.25)',
  },
  {
    name: 'Agency Pro',
    price: '$599',
    priceId: 'price_1TPqK6Kvsr6YPyDcFa2YGmkg',
    features: ['Up to 10 agents', 'All Pro features per agent'],
    color: '#f472b6',
    dim: 'rgba(244,114,182,0.1)',
    border: 'rgba(244,114,182,0.25)',
  },
  {
    name: 'Agency Elite',
    price: '$1,499',
    priceId: 'price_1TPqKfKvsr6YPyDc5EtALQmv',
    features: ['Up to 20 agents', 'All Elite features per agent', 'Admin dashboard (coming soon)', 'Manager insights (coming soon)'],
    color: '#fbbf24',
    dim: 'rgba(251,191,36,0.1)',
    border: 'rgba(251,191,36,0.25)',
  },
];
 
const API = 'https://objectionready-production.up.railway.app';
 
function PlanCard({ plan, loading, onSelect }) {
  return (
    <div style={{
      background: '#111113',
      border: `0.5px solid ${plan.popular ? plan.border : 'rgba(255,255,255,0.07)'}`,
      borderRadius: '12px',
      padding: '20px',
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
    }}>
      {plan.popular && (
        <div style={{ position: 'absolute', top: '-10px', left: '50%', transform: 'translateX(-50%)', background: plan.dim, border: `0.5px solid ${plan.border}`, borderRadius: '99px', padding: '2px 12px', fontSize: '10px', fontWeight: '500', color: plan.color, whiteSpace: 'nowrap' }}>
          Most popular
        </div>
      )}
      <div style={{ marginBottom: '12px' }}>
        <p style={{ fontSize: '13px', fontWeight: '500', color: plan.color, marginBottom: '6px' }}>{plan.name}</p>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: '2px' }}>
          <span style={{ fontSize: '26px', fontWeight: '600', color: '#f0efe8' }}>{plan.price}</span>
          <span style={{ fontSize: '12px', color: '#888880' }}>/month</span>
        </div>
      </div>
      <div style={{ flex: 1, marginBottom: '16px' }}>
        {plan.features.map((f, i) => (
          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '5px 0', borderBottom: '0.5px solid rgba(255,255,255,0.05)' }}>
            <span style={{ color: plan.color, fontSize: '11px', flexShrink: 0 }}>✓</span>
            <span style={{ fontSize: '12px', color: '#888880' }}>{f}</span>
          </div>
        ))}
      </div>
      <button
        onClick={() => onSelect(plan)}
        disabled={loading === plan.priceId}
        style={{
          width: '100%', padding: '10px', fontSize: '13px', fontWeight: '500',
          borderRadius: '6px', cursor: 'pointer',
          background: plan.dim, border: `0.5px solid ${plan.border}`, color: plan.color,
          fontFamily: 'DM Sans, sans-serif'
        }}>
        {loading === plan.priceId ? 'Loading...' : 'Start free trial →'}
      </button>
    </div>
  );
}
 
export default function Pricing({ session }) {
  const [loading, setLoading] = useState(null);
 
  const handleSelect = async (plan) => {
    setLoading(plan.priceId);
    try {
      const res = await fetch(`${API}/stripe/checkout`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ priceId: plan.priceId, email: session.user.email })
      });
      const data = await res.json();
      if (data.url) window.location.href = data.url;
    } catch (e) {
      alert('Something went wrong. Please try again.');
    }
    setLoading(null);
  };
 
  const handleSignOut = async () => {
    await supabase.auth.signOut();
  };
 
  return (
    <div style={{ minHeight: '100vh', background: '#0a0a0b', fontFamily: 'DM Sans, sans-serif', padding: '32px 16px 80px' }}>
      <div style={{ maxWidth: '960px', margin: '0 auto' }}>
 
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '40px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#4ade80', boxShadow: '0 0 8px #4ade80' }}></div>
            <span style={{ fontSize: '14px', fontWeight: '500', color: '#888880' }}>ObjectionReady</span>
          </div>
          <button onClick={handleSignOut} style={{ fontSize: '12px', color: '#555550', background: 'transparent', border: 'none', cursor: 'pointer' }}>Sign out</button>
        </div>
 
        <div style={{ textAlign: 'center', marginBottom: '48px' }}>
          <h1 style={{ fontSize: '28px', fontWeight: '600', color: '#f0efe8', marginBottom: '8px' }}>Choose your plan</h1>
          <p style={{ fontSize: '14px', color: '#888880' }}>3-day free trial on all plans · Cancel anytime</p>
        </div>
 
        <div style={{ marginBottom: '40px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
            <span style={{ fontSize: '12px', fontWeight: '500', color: '#555550', textTransform: 'uppercase', letterSpacing: '.08em' }}>Individual</span>
            <div style={{ flex: 1, height: '0.5px', background: 'rgba(255,255,255,0.07)' }}></div>
          </div>
          <div style={{ display: 'flex', gap: '12px', alignItems: 'stretch' }}>
            {INDIVIDUAL_PLANS.map(plan => (
              <PlanCard key={plan.priceId} plan={plan} loading={loading} onSelect={handleSelect} />
            ))}
          </div>
        </div>
 
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
            <span style={{ fontSize: '12px', fontWeight: '500', color: '#555550', textTransform: 'uppercase', letterSpacing: '.08em' }}>Agency</span>
            <div style={{ flex: 1, height: '0.5px', background: 'rgba(255,255,255,0.07)' }}></div>
          </div>
          <div style={{ display: 'flex', gap: '12px', alignItems: 'stretch' }}>
            {AGENCY_PLANS.map(plan => (
              <PlanCard key={plan.priceId} plan={plan} loading={loading} onSelect={handleSelect} />
            ))}
          </div>
        </div>
 
      </div>
    </div>
  );
}